import { createTypes } from "../../utils/helpers";

const RESTAURANT_ZONES_FETCH:any = createTypes('RESTAURANT_ZONES_FETCH');
export { RESTAURANT_ZONES_FETCH };
